import type { PrintoutColumnType } from "../types";

/**
 * Horizontal-pivot mode is active iff `columnGroupingBy` is a non-null column kind.
 *
 * Single source of truth — consulted by layout, render, and the `mergeSimilarShiftTimes`
 * predicate. Mapping §6.1, §8.2.
 */
export const isPivotActive = (columnGroupingBy: PrintoutColumnType | null | undefined): columnGroupingBy is PrintoutColumnType => {
	return columnGroupingBy != null;
};
